import { Button, createTheme, Dialog, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Pagination, Select, Slide, TextField, ThemeProvider, Tooltip } from '@mui/material'
import MUIDataTable from 'mui-datatables'
import React, { useEffect, useState } from 'react'
import { CalendarAPI } from '../../api/CalendarAPI'
import { useDispatch, useSelector } from 'react-redux';
import { TbCalendarCheck } from "react-icons/tb";
import { RiProgress3Line } from "react-icons/ri";
import { MdOutlineFreeCancellation } from "react-icons/md";
import Loader from '../../component/Loader';
import { PiCurrencyDollarFill } from "react-icons/pi";
import { PaymentAPI } from '../../api/PaymentAPI';
import PopUpAlert from '../../component/PopUpAlert'
import { calenderAction } from '../../redux/reducer/calenderReducer';
import { TiDeleteOutline } from "react-icons/ti";
import { MdOutlineErrorOutline } from "react-icons/md";
import { Privileges } from '../../util/PrivilegeConstants';
import { BsDashLg } from "react-icons/bs";
import { isClubOwner, isClubStaff } from '../../util/UserRoles';
import { PrivilegeAPI } from '../../api/PrivilegesAPI';
import { rootAction } from '../../redux/reducer/rootReducer';


const rootStyle = getComputedStyle(document.documentElement);
const color = rootStyle.getPropertyValue("--hoverColorBold").trim();
const timeOptions = {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
};
const getMuiTheme = () => createTheme({
    typography: {
        fontFamily: 'sans-serif'
    },
    shape: {
        borderRadius: 10,
    },
    components: {

        MuiTablePagination: {
            styleOverrides: {
                displayedRows: {
                    margin: 0,
                    fontSize: 15
                },
                selectLabel: {
                    margin: 0,
                    fontSize: 15
                },
                selectRoot: {
                    margin: 0,
                    fontSize: 15,
                },
                toolbar: {
                    display: 'flex',
                    gap: 20
                }
            }
        },
        MUIDataTableToolbar: {
            styleOverrides: {
                icon: {
                    '&:hover': {
                        color: color
                    }
                },
                iconActive: {
                    color: color
                }
            },
        },
        MUIDataTableSearch: {
            styleOverrides: {
                clearIcon: {
                    '&:hover': {
                        color: color
                    }
                }
            }
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    '&:after': {
                        borderBottom: '2px solid ' + color,    // Underline color when focused
                    },
                },
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-focused': {
                        color: color
                    }
                }
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: color
                    }
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    padding: '0px 5px'
                }
            }
        }
        ,
        MuiTypography: {
            styleOverrides: {
                body1: {
                    minHeight: '40vh'

                }
            }
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    borderRadius: 0,
                },
            }

        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    whiteSpace: 'nowrap',
                    textTransform: 'uppercase',
                    fontSize: 15,
                },
                body: {
                    fontSize: '15px',
                    textAlign: "start",
                    border: 'none'
                },
                footer: {
                    padding: '10px'
                },
            }
        },
        MUIDataTableSelectCell: {
            styleOverrides: {
                root: {
                    background: 'white'
                }
            }
        },
        MuiTouchRipple: {
            styleOverrides: {
                root: {
                    color: color
                }
            }
        },
        MUIDataTableFilter: {
            styleOverrides: {
                resetLink: {
                    color: color
                }
            }
        },
        MUIDataTableHeadCell: {
            styleOverrides: {
                data: {
                    textTransform: 'uppercase'
                }
            }
        }

    }
})
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const ReservationHistory = () => {
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const { pageNumber, pageSize } = useSelector((store) => store.calendar);
    const dispatch = useDispatch();
    
    const [reservations, setReservations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [amount, setAmount] = useState('');
    const [reason, setReason] = useState('REQUESTED_BY_CUSTOMER');
    const [reservationId, setReservationId] = useState('');
    const [refresh, setRefresh] = useState(false);
    const [count, setCount] = useState(0);
    const [privileges, setPrivileges] = useState({});


    const fetchAllReservation = async () => {
        try {
            setLoading(true);
            const response1 = await CalendarAPI.getAllGames(selectedClub.clubId);
            const response2 = await CalendarAPI.getAllReservationHistory({
                clubId: selectedClub.clubId,
                gameId: response1[0]?.gameId,
                userId: userInfo?.userId,
                isUserAdmin: isClubOwner(userInfo),
                isUserStaff: isClubStaff(userInfo),
                pageSize: pageSize,
                pageNumber: pageNumber
            });
            setReservations(response2.Data);
            setCount(response2?.Data[0]?.totalReservation);


            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    const handleRefund = (price, rId) => {
        setAmount(price);
        setReservationId(rId);
        setOpenPopup(true)
    }
    const handleRefundAPI = async (event) => {
        event.preventDefault();
        setOpenPopup(false);
        try {
            const refundInfo = {
                userId: userInfo.userId,
                clubId: selectedClub.clubId,
                reservationId: reservationId,
                reason: reason,
                amount: amount,
            }
            setLoading(true);
            const response = await PaymentAPI.postCreateRefund(refundInfo);

            dispatch(rootAction.setWarningMessage({id:Date.now(), type: 'success', content: response.Data }));
            setLoading(false);
            setRefresh(true);
        } catch (error) {
            dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Please contact customer support' }));
            setLoading(false);
        }
    }

    const findAllPrivileges = async () => {
        try {
            setLoading(true)
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[6]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (userInfo.userId) {
            findAllPrivileges();
        }
    }, [userInfo.userId])

    useEffect(() => {
        if (selectedClub?.clubId) {
            fetchAllReservation();
        }
        setRefresh(false);
    }, [selectedClub?.clubId, refresh, pageNumber, pageSize]);


    const columns = [
        {
            name: "reservationOrderId",
            label: "Order Id",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (val) => <div style={{ margin: 0, whiteSpace: 'nowrap', textAlign: 'center' }}>{val || <BsDashLg />}</div>
            }
        },
        {
            name: "startTime",
            label: "Start Time",
            options: {
                filter: false,
                sort: true,
                customBodyRender: (val) => <div style={{ margin: 0, whiteSpace: 'nowrap' }}>{val && new Date(val).toLocaleString('en-US', timeOptions)}</div>
            }
        },
        {
            name: "reservationId",
            label: "reservationId",
            options: {
                filter: false,
                sort: false,
                display: false
            }
        },
        {
            name: "endTime",
            label: "End Time",
            options: {
                filter: false,
                sort: true,
                customBodyRender: (val) => <div style={{ margin: 0, whiteSpace: 'nowrap' }}>{val && new Date(val).toLocaleString('en-US', timeOptions)}</div>
            }

        },
        {
            name: "resourceName",
            label: "Court",
            options: {
                filter: false,
                sort: true,
                customBodyRender: (val) => <div style={{ margin: 0 }}>{val}</div>
            }

        },
        {
            name: "reservationStatus",
            label: "Status",
            options: {
                setCellProps: () => ({
                    style: {
                        display: 'flex',
                        width: 'max-content',
                    },
                }),
                filter: true,
                sort: true,
                customBodyRender: (val) => (<div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: 0,

                    }}>
                    {val === 'RESERVED' &&
                        <>
                            <TbCalendarCheck data-testid="reservation_status_incon_reserved" className='reservation_status_incon_reserved' />
                            <span>{val.charAt(0).toUpperCase() + val.slice(1).toLowerCase()}</span>
                        </>
                    }
                    {val === 'IN-PROGRESS' &&
                        <>
                            <RiProgress3Line data-testid="reservation_status_incon_inprogress" className="reservation_status_incon_inprogress" />
                            <span>{val.replace('-', ' ').charAt(0).toUpperCase() + val.replace('-', ' ').slice(1).toLowerCase()}</span>
                        </>
                    }
                    {val === 'CANCELED ADMIN' &&
                        <Tooltip title={`Canceled by ${val?.substring(9, 10) + val?.substring(10).toLowerCase()}`} placement="top">
                            <div style={{ display: 'flex' }}>
                                <MdOutlineFreeCancellation data-testid="reservation_status_incon_canceled" className="reservation_status_incon_canceled" />
                                <span>{val?.charAt(0).toUpperCase() + val.substring(1, 8).toLowerCase()}</span>
                            </div>
                        </Tooltip>
                    }
                    {val === 'CANCELED STAFF' &&
                        <Tooltip title={`Canceled by ${val?.substring(9, 10) + val?.substring(10).toLowerCase()}`} placement="top">
                            <div style={{ display: 'flex' }}>
                                <MdOutlineFreeCancellation data-testid="reservation_status_incon_canceled" className="reservation_status_incon_canceled" />
                                <span>{val?.charAt(0).toUpperCase() + val.substring(1, 8).toLowerCase()}</span>
                            </div>
                        </Tooltip>
                    }
                    {val === 'DELETED' &&
                        <>
                            <TiDeleteOutline data-testid="reservation_status_incon_deleted" className="reservation_status_incon_canceled" />
                            <span>{val?.charAt(0).toUpperCase() + val.slice(1).toLowerCase()}</span>
                        </>
                    }
                    {val === 'NOT-PAID' &&
                        <>
                            <MdOutlineErrorOutline data-testid="reservation_status_incon_notpaid" className="reservation_status_incon_canceled" />
                            <span>{val?.replace('-', ' ').charAt(0).toUpperCase() + val.replace('-', ' ').slice(1).toLowerCase()}</span>
                        </>
                    }
                </div>)
            }
        },
        {
            name: "reservationCreatedByName",
            label: "Created By",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (val) => <div style={{ margin: 0, whiteSpace: 'nowrap' }}>{val}</div>
            }
        },
        {
            name: "amount",
            label: "Amount",
            options: {
                filter: false,
                sort: true,
                customBodyRender: (val) => <div
                    style={{
                        margin: 0,
                        display: 'flex',
                        alignItems: 'center'
                    }}>
                    <PiCurrencyDollarFill className="reservation_amount_incon_reserved" />
                    {Number(val)?.toFixed(2)}</div>
            }
        },
        {
            name: "reservationStatus",
            label: "Action",
            options: {
                customBodyRender: (val, data) => (
                    <>
                        {((data?.rowData[7] !== '0') && val === 'RESERVED' && privileges?.RESERVATION?.includes(Privileges.DELETE)) &&
                            <button
                                onClick={() =>
                                    handleRefund(Number(data.rowData[7]).toFixed(2), data.rowData[2])
                                }
                                data-testid="reservation_refund_button"
                                className='reservation_refund_button'
                                type='button'>
                                Refund
                            </button>
                        }
                        {((data?.rowData[7] !== '0') && (val === 'CANCELED ADMIN' || val === 'CANCELED STAFF')) &&
                            <button
                                disabled
                                data-testid="reservation_refund_button_disabled"
                                className='reservation_refund_button disabled'
                                type='button'>
                                Refunded
                            </button>
                        }
                    </>
                ),
                filter: false,
                sort: false,
                display: isClubOwner(userInfo) || isClubStaff(userInfo)
            }
        },
    ];
    const options = {
        search: true,
        download: false,
        print: true,
        viewColumns: false,
        filter: true,
        filterType: 'dropdown',
        responsive: 'standard',
        rowsPerPage: pageSize,
        pagination: false,
        rowsPerPageOptions: [5, 10, 15, 20],
        selectableRows: "none",
    };

    return (
        <div className='reservation_history_container'>
            {loading && <Loader />}
            <div className="add-member-heading">
                <h1>Reservation History</h1>
            </div>
            <div className="member-list-table">
                <ThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        data={reservations}
                        columns={columns}
                        options={options}
                    />
                </ThemeProvider>
                <div className='reservation_history_pagination'>
                    <Pagination
                        count={count ? ((count % pageSize) == 0 ? Math.floor(count / pageSize) : Math.floor(count / pageSize) + 1) : 0}
                        page={pageNumber}
                        onChange={(event, value) => {
                            dispatch(calenderAction.setPageNumber(value));
                        }}
                        className="reservation-custom-pagination"
                        variant="outlined" />
                </div>
            </div>
            <Dialog
                open={openPopup}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setOpenPopup(false)}
            >
                <DialogTitle sx={{ fontFamily: 'sans-serif', fontWeight: 600 }}>{"Send refund"}</DialogTitle>
                <DialogContent>
                    <DialogContentText component={'span'} sx={{ marginTop: 1 }} id="alert-dialog-slide-description">
                        <form className="reservation-refund-form" onSubmit={handleRefundAPI}>
                            <p>Refunds take 5-10 days to appear on a customer's statement. Fees for the original payment won't be returned, but there are no additional fees for the refund. </p>
                            <div className="reservation-refund-input">
                                <TextField
                                    fullWidth
                                    className="reservation-amount-text-input"
                                    variant="outlined"
                                    name="firstName"
                                    value={amount || ''}
                                    label="Amount *" />
                                <FormControl
                                    fullWidth
                                    data-testid="game-dropdown" className='calender-game-dropdown'
                                >
                                    <InputLabel id="demo-simple-select-autowidth-label">Reason</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-autowidth-label"
                                        id="demo-simple-select-autowidth"
                                        value={reason || ''}
                                        onChange={(e) => setReason(e.target.value)}
                                        label="Reason"
                                    >
                                        <MenuItem value="REQUESTED_BY_CUSTOMER">Request from customer</MenuItem>
                                        <MenuItem value="FRAUDULENT">Fraudulent</MenuItem>
                                        <MenuItem value="DUPLICATE">Duplicate</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div className="member-details-btn">
                                <Button
                                    onClick={() => setOpenPopup(false)}
                                    color="error"
                                    variant="outlined">Cancel</Button>

                                <Button
                                    type="submit"
                                    variant="contained">Refund</Button>
                            </div>
                        </form>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default ReservationHistory